require('./classifieds.component');
require('./classifieds-menu.component');
require('./classifieds-list.component');
require('./my-advertisements.component');
require('./rent-out-bookings.component');
require('./rent-bookings.component');
